<ng-container>
  <div class="row mb-0">
    <div class="col">
      <app-search [required]="isNotAPonton" [(ngModel)]="selectedDetails"
                  [searchFunction]="findVesselContactDetails"
                  [resultFormatter]="communicationFormatter"
                  [inputFormatter]="communicationFormatter"
                  (ngModelChange)="onCommunicationDetailChange($event)"
                  [alwaysShowNewValue]="false"
                  [minCharacters]="0"
                  [showDelete]=true
                  [deleteFunction]="deleteContactDetails"
                  [emptyOnBlur]="false">
      </app-search>
    </div>
  </div>
</ng-container>
